"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOpen = setOpen;
exports.setClosed = setClosed;
exports.setZoom = setZoom;
exports.setCoordinates = setCoordinates;
exports.setActiveFarmId = setActiveFarmId;

function setOpen() {
  return {
    type: 'map-set-open'
  };
}

function setClosed() {
  return {
    type: 'map-set-closed'
  };
}

function setZoom(zoom) {
  return {
    type: 'map-update-zoom',
    zoom: zoom
  };
}

function setCoordinates(lat, lon) {
  return {
    type: 'map-update-coordinates',
    lat: lat,
    lon: lon
  };
}

function setActiveFarmId(farmId) {
  return {
    type: 'map-set-active-farm-id',
    farmId: farmId
  };
}


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-map/actions.js
// module id = 872
// module chunks = 0